/* eslint-disable import/no-unresolved, import/no-extraneous-dependencies */
import React from 'react';
import { Button } from '@mantine/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAlert, AlertType } from 'src/components/AlertsProvider';
import { useOmniverseConfig } from '../hooks/useConfig';
import { StreamingSession, terminateSession } from '../state/Sessions';

export interface SessionTerminateButtonProps {
  session: StreamingSession;
}

export default function SessionTerminateButton({
  session,
}: SessionTerminateButtonProps) {
  const config = useOmniverseConfig();
  const queryClient = useQueryClient();
  const { showAlert } = useAlert();

  const { isPending, mutate: terminate } = useMutation({
    mutationFn: async () => {
      if (
        window.confirm(
          `Are you sure you want to terminate session ${session.id}? This will disconnect the stream if it's active. All unsaved work will be lost.`
        )
      ) {
        try {
          await terminateSession({ config, sessionId: session.id });
        } catch (error) {
          const message =
            error instanceof Error ? error.message : error?.toString?.() ?? '';

          showAlert({
            type: AlertType.Error,
            title: 'Failed to terminate session',
            text: message,
          });
        }
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sessions'] });
      queryClient.invalidateQueries({ queryKey: ['app-sessions'] });
    },
  });

  return (
    <Button color={'red'} loading={isPending} onClick={() => terminate()}>
      Terminate
    </Button>
  );
}
